import * as storeTypes from "./export.store-types";
import axios from "axios";

export default {
    namespaced: true,
    state: {
    },
    mutations: {},
    actions: {
        async [storeTypes.ACTION_EXPORT_USER_OVP_STATUS](
            store, { companyId, onlyWaitingForApproval }
        ) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const { data } = await axios.post(`/api/export/${companyId}/user-ovp-status`, { onlyWaitingForApproval })
                        window.open(data, '_blank')
                        resolve()

                    } catch ({ message }) {
                        reject(message)
                    }
                })()
            });
        }
    },
    getters: {}
};
